interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  return (
    <>
      {/* desktop numbered pagination */}
      <div className="mt-10 hidden items-center justify-center gap-2 md:flex">
        <button
          type="button"
          disabled={page === 1}
          onClick={() => onChange(page - 1)}
          className="flex h-10 items-center gap-1 rounded-full border border-background-200 px-4 text-sm text-foreground-700 transition enabled:hover:border-primary-400 enabled:hover:text-primary-700 disabled:cursor-not-allowed disabled:opacity-40"
        >
          <i className="ri-arrow-left-s-line"></i>
          上一页
        </button>
        {pages.map((p) => (
          <button
            key={p}
            type="button"
            onClick={() => onChange(p)}
            className={`h-10 w-10 rounded-full text-sm font-medium transition ${
              p === page
                ? "bg-primary-500 text-foreground-950"
                : "border border-background-200 text-foreground-700 hover:border-primary-400 hover:text-primary-700"
            }`}
          >
            {p}
          </button>
        ))}
        <button
          type="button"
          disabled={page === totalPages}
          onClick={() => onChange(page + 1)}
          className="flex h-10 items-center gap-1 rounded-full border border-background-200 px-4 text-sm text-foreground-700 transition enabled:hover:border-primary-400 enabled:hover:text-primary-700 disabled:cursor-not-allowed disabled:opacity-40"
        >
          下一页
          <i className="ri-arrow-right-s-line"></i>
        </button>
      </div>

      {/* mobile load more */}
      <div className="mt-8 flex flex-col items-center gap-2 md:hidden">
        {page < totalPages ? (
          <button
            type="button"
            onClick={() => onChange(page + 1)}
            className="flex w-full max-w-xs items-center justify-center gap-2 rounded-full bg-primary-500 py-3.5 text-sm font-semibold text-foreground-950"
          >
            <i className="ri-add-line text-lg"></i>
            加载更多
          </button>
        ) : (
          <p className="text-xs text-foreground-400">— 已经看到底啦 —</p>
        )}
        <p className="text-xs text-foreground-500">
          已显示 {page} / {totalPages} 页
        </p>
      </div>
    </>
  );
}